import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=773ec1eb&"
import script from "./DropZone.vue?vue&type=script&lang=js&"
export * from "./DropZone.vue?vue&type=script&lang=js&"
import style0 from "./DropZone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773ec1eb')) {
      api.createRecord('773ec1eb', component.options)
    } else {
      api.reload('773ec1eb', component.options)
    }
    module.hot.accept("./DropZone.vue?vue&type=template&id=773ec1eb&", function () {
      api.rerender('773ec1eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DropZone.vue"
export default component.exports